module.exports = __webpack_public_path__ + "fe842845abcc359f2fc326ddafcd393f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg3.jpg
 ** module id = 508
 ** module chunks = 1
 **/